import dayjs, { Dayjs } from 'dayjs';

import { DATE_FORMAT } from 'consts';

export const formatDate = (date?: Dayjs | string | number | null, format: string = DATE_FORMAT) => {
  if (!date) return '';
  return dayjs(date).format(format);
};
